import { useState } from 'react';
import { Link } from 'react-router-dom';
import toast from 'react-hot-toast';

import { supabase } from '@/lib/supabase';
import { Button, Input } from '@realvisor/ui';

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);

    try {
      const { error } = await supabase.auth.resetPasswordForEmail(email, {
        redirectTo: `${window.location.origin}/reset-password`,
      });
      if (error) throw error;
      setSubmitted(true);
    } catch {
      toast.error('Nepodařilo se odeslat e-mail');
    } finally {
      setIsLoading(false);
    }
  };

  if (submitted) {
    return (
      <div className="text-center">
        <h2 className="text-2xl font-bold text-gray-900">E-mail odeslán</h2>
        <p className="mt-4 text-gray-600">
          Pokud existuje účet s e-mailem {email}, obdržíte odkaz pro obnovení hesla.
        </p>
        <Link
          to="/login"
          className="mt-6 inline-block text-sm font-medium text-primary-600 hover:text-primary-500"
        >
          Zpět na přihlášení
        </Link>
      </div>
    );
  }

  return (
    <>
      <div>
        <h2 className="text-2xl font-bold text-gray-900">Zapomenuté heslo</h2>
        <p className="mt-2 text-sm text-gray-600">
          Zadejte svůj e-mail a my vám pošleme odkaz pro obnovení hesla.
        </p>
      </div>

      <form onSubmit={handleSubmit} className="mt-8 space-y-6">
        <Input
          label="E-mail"
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
          autoComplete="email"
        />

        <Button type="submit" className="w-full" isLoading={isLoading}>
          Odeslat odkaz
        </Button>

        <p className="text-center text-sm text-gray-600">
          <Link to="/login" className="font-medium text-primary-600 hover:text-primary-500">
            Zpět na přihlášení
          </Link>
        </p>
      </form>
    </>
  );
}
